import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Option } from '@shared/types/components.type';

@Component({
  imports: [NgSelectModule, TooltipDirective, FormsModule],
  selector: 'aux-forecast-table-grid-period-custom-curve',
  styleUrl: './forecast-table-grid-period-custom-curve.component.scss',
  templateUrl: './forecast-table-grid-period-custom-curve.component.html',
})
export class ForecastTableGridPeriodCustomCurveComponent {
  options: Option<string>[] = [
    {
      label: 'Patient Curves',
      value: 'Patient Curves',
    },
  ];
  selectedPeriodPatientOption = 'Custom Curve';
  @Input() tooltip = '';
}
